import { Card, CardContent, Link, Typography } from "@mui/material";
import { InfoWindow, Marker } from "@react-google-maps/api";
import React from "react";
export const MapMarker = ({ clusterer, retailer }) => {
    const [isWindowOpen, setIsWindowOpen] = React.useState(false);
    const toggleWindowState = () => setIsWindowOpen((curr) => !curr);
    return (React.createElement(Marker, { key: retailer._id, onClick: toggleWindowState, position: {
            lat: retailer.coordinates.coordinates[1],
            lng: retailer.coordinates.coordinates[0],
        }, clusterer: clusterer }, isWindowOpen && (React.createElement(InfoWindow, { key: `info-window-${retailer._id}`, onCloseClick: toggleWindowState },
        React.createElement(MapMarkerInfo, { retailer: retailer })))));
};
export const MapMarkerInfo = ({ retailer }) => {
    if (!retailer)
        return null;
    return (React.createElement(Card, { variant: "outlined", sx: { backgroundColor: "white" } },
        React.createElement(CardContent, null,
            React.createElement(Typography, { component: "p", variant: "h5" }, retailer.name),
            React.createElement(Typography, { variant: "caption", component: "p" },
                retailer.address.street,
                ", ",
                retailer.address.postalCode,
                " ",
                retailer.address.city),
            retailer.url && (React.createElement(Typography, { variant: "caption", component: "p" },
                React.createElement(Link, { href: retailer.url }, retailer.url))))));
};
//# sourceMappingURL=map-marker.js.map